const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const request = async (path, options = {}) => {
  const token = localStorage.getItem('token');
  const res = await fetch(`${BASE_URL}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    ...options,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
};

export const api = {
  auth: {
    register: (body) => request('/auth/register', { method: 'POST', body: JSON.stringify(body) }),
    login: (body) => request('/auth/login', { method: 'POST', body: JSON.stringify(body) }),
  },
  anime: {
    search: (q, page = 1) => request(`/anime/search?q=${encodeURIComponent(q)}&page=${page}`),
    get: (id) => request(`/anime/${id}`),
    episodes: (id) => request(`/anime/${id}/episodes`),
    watch: (episodeId) => request(`/anime/watch/${episodeId}`),
  },
  watchlist: {
    list: () => request('/watchlist'),
    add: (animeId) => request(`/watchlist/${animeId}`, { method: 'POST' }),
    remove: (animeId) => request(`/watchlist/${animeId}`, { method: 'DELETE' }),
  },
};
